import { styled } from '@mui/material';
import { colors } from '../../../options/colors';

export const Title = styled('div')(() => ({
  textTransform: 'uppercase',
  fontSize: 35,

}));

export const LeaderboardContainer = styled('div')(() => ({
  padding: 0
}));

export const TableStatsContainer = styled('div')(() => ({
  marginBottom: 15,
  paddingTop: 6,
}));

export const DataHeaders = styled('div')(() => ({
  fontSize: 20,
  padding: 0,
  borderBottom: `1px ${colors.printStatsRed} solid`
}));

export const DataCells = styled('div')(() => ({
  fontSize: '18px',
  fontWeight: 300,
  paddingTop: 10,
  paddingBottom: 0,
}));